export default defineNuxtRouteMiddleware(async () => {
    const { getToken } = useUser()
    const { URL_LOGIN_SUCCESS } = useAppConfig()
    const { $i18n } = useNuxtApp()
    const { siteUrl } = useRuntimeConfig().public

    const token = await getToken()

    if (token) {
        navigateTo(`${siteUrl}/${$i18n.locale.value}${URL_LOGIN_SUCCESS}`, {
            external: true,
        })
    }
})
